import EventEmitter from 'amkit3-modules/utils/stateful-events'
import UIEvent from 'amkit3-modules/v/ui/ui-event'

import HuyaUIEvent from './huya-ui-event'
import ProgressBar from './progress-bar'
import TimeDisplay from './time-display'
import VolumeSlider from './volume-slider'

import themeFactory from './themes/factory'

import yaApi from 'amkit3-modules/utils/huya/ya-api'

// const LABEL_MAPS = {
//   350: '流畅',
//   1000: '高清',
//   1300: '超清',
//   yuanhua: '原画',
// };

class ControlBar extends EventEmitter {
  constructor($, $container, options) {
    super()

    this.$ = $
    this.$container = $container
    this.options = options

    this.style = themeFactory.getStyle()
    this.selector = themeFactory.getSelector()

    this.$playButton = $container.find(this.selector.controlBarPlayButton)
    this.$pauseButton = $container.find(this.selector.controlBarPauseButton)
    this.$replayButton = $container.find(this.selector.controlBarReplayButton)
    this.$volumeButton = $container.find(this.selector.controlBarVolumeButton)

    this.$container.on(
      'click',
      this.selector.controlBarPlayButton,
      this.statefulDelegate(evt => {
        this.setPause()
        this.emit(UIEvent.PLAY_BUTTON_CLICK)
      }),
    )
    this.$container.on(
      'click',
      this.selector.controlBarPauseButton,
      this.statefulDelegate(evt => {
        this.setPlay()
        this.emit(UIEvent.PAUSE_BUTTON_CLICK)
      }),
    )
    this.$container.on(
      'click',
      this.selector.controlBarReplayButton,
      this.statefulDelegate(evt => {
        this.setPause()
        this.emit(UIEvent.REPLAY_BUTTON_CLICK)
      }),
    )
    this.$container.on(
      'click',
      this.selector.controlBarFullscreenButton,
      this.statefulDelegate(evt => {
        this.emit(UIEvent.FULLSCREEN_BUTTON_CLICK)
      }),
    )
    this.$container.on(
      'click',
      this.selector.controlBarVolumeButton,
      this.statefulDelegate(evt => {
        if (this.volume !== 0) {
          this.volume = 0
          this.$volumeButton.addClass(this.style.controlBarVolumeButtonMute)
        } else {
          this.volume = 0.5
          this.$volumeButton.removeClass(this.style.controlBarVolumeButtonMute)
        }
        this.volumeSlider.setVolume(this.volume)
        this.emit(UIEvent.VOLUME_CHANGE)
      }),
    )

    // ORIGIN EVENTS
    this.$container.on('click', this.selector.controlBarPlayButton, evt => {
      this.emit(UIEvent.PLAY_BUTTON_CLICK_O)
    })

    this.progressBar = new ProgressBar(this.$, this.$container)
    this.progressBar.on(
      UIEvent.TIME_CHANGE,
      this.statefulDelegate(() => {
        this.time = this.progressBar.getTime()
        this.timeDisplay.setTime(this.time)
        this.emit(UIEvent.TIME_CHANGE)
      }),
    )
    this.timeDisplay = new TimeDisplay(this.$, this.$container)
    this.volumeSlider = new VolumeSlider(this.$, this.$container)
    this.volumeSlider.on(
      UIEvent.VOLUME_CHANGE,
      this.statefulDelegate(() => {
        this.volume = this.volumeSlider.getVolume()
        if (this.volume <= 0) {
          this.$volumeButton.addClass(this.style.controlBarVolumeButtonMute)
        } else {
          this.$volumeButton.removeClass(this.style.controlBarVolumeButtonMute)
        }
        this.emit(UIEvent.VOLUME_CHANGE)
      }),
    )

    // HuyaUI definition change
    this.$container.on(
      'click',
      this.selector.controlBarDefinitionPanelItem,
      this.statefulDelegate(evt => {
        let definition =
          this.$(evt.srcElement).data('definition') || this.$(evt.target).data('definition')
        const oldDefinition = this.definition
        this.setDefinition(definition)
        this.emit(HuyaUIEvent.DEFINITION_CHANGE)
        yaApi.yaReport({
          eid: 'usr/click/resolution/player',
          eid_desc: '用户/点击/分辨率/播放器',
          prop: JSON.stringify({
            'target-resolution': definition,
            'before-resolution': oldDefinition,
          }),
        })
      }),
    )

    // HuyaUI playbackRate change
    this.$container.on(
      'click',
      this.selector.controlBarPlaybackRatePanelItem,
      this.statefulDelegate(evt => {
        let playbackRate = this.$(evt.srcElement).data('label') || this.$(evt.target).data('label')
        const oldPlaybackRate = this.getPlaybackRate()
        this.setPlaybackRate(playbackRate)
        this.emit(HuyaUIEvent.PLAYBACK_RATE_CHANGE)
        yaApi.yaReport({
          eid: 'usr/click/speed/player',
          eid_desc: '用户/点击/播放速度/播放器',
          prop: JSON.stringify({
            'target-speed': this.getPlaybackRate(),
            'before-speed': oldPlaybackRate,
          }),
        })
      }),
    )
  }
  setPlay() {
    this.statefulDelegate(() => {
      this.$playButton.show()
      this.$pauseButton.hide()
      this.$replayButton.hide()
    })()
  }
  setPause() {
    this.statefulDelegate(() => {
      this.$playButton.hide()
      this.$pauseButton.show()
      this.$replayButton.hide()
    })()
  }
  setReplay() {
    this.statefulDelegate(() => {
      this.$playButton.hide()
      this.$pauseButton.hide()
      this.$replayButton.show()
    })()
  }
  setDuration(value) {
    this.statefulDelegate(() => {
      this.duration = value
      this.progressBar.setDuration(value)
      this.timeDisplay.setDuration(value)
    })()
  }
  setTime(value) {
    this.statefulDelegate(value => {
      this.time = value
      this.progressBar.setTime(value)
      this.timeDisplay.setTime(value)
    })(value)
  }
  getTime() {
    return this.time
  }
  setVolume(value) {
    this.volume = value
    this.volumeSlider.setVolume(value)
    if (this.volume <= 0) {
      this.$volumeButton.addClass(this.style.controlBarVolumeButtonMute)
    } else {
      this.$volumeButton.removeClass(this.style.controlBarVolumeButtonMute)
    }
  }
  getVolume() {
    return this.volume
  }
  setDefinition(definition) {
    this.statefulDelegate(definition => {
      this.definition = definition
      this.$container.find(this.selector.controlBarDefinitionPanelItem).each((index, item) => {
        if (String(this.$(item).data('definition')) === String(definition)) {
          this.$(item).addClass(this.style.controlBarDefinitionPanelItemSelected)
          this.$container.find(this.selector.controlBarDefinitionLabel).text(this.$(item).text())
        } else {
          this.$(item).removeClass(this.style.controlBarDefinitionPanelItemSelected)
        }
      })
    })(definition)
  }
  setDefinitions(definitions) {
    this.statefulDelegate(definitions => {
      const node = definitions.reduce((currentStr, definitionConfig) => {
        currentStr = `${currentStr}<div class=${this.style.controlBarDefinitionPanelItem} data-definition=${definitionConfig.definition}>${definitionConfig.label}</div>`
        return currentStr
      }, '')
      this.$container.find(this.selector.controlBarDefinitionPanel).html(node)
      this.$container.find(this.selector.controlBarDefinition).css('display', 'flex')
      // this.$container.find(this.selector.controlBarDefinitionPanelItem).each((index, item) => {
      //   if (labels.indexOf(String(this.$(item).data('label'))) >= 0) {
      //     this.$(item).removeClass(this.style.controlBarDefinitionPanelItemInvalid)
      //   } else {
      //     this.$(item).addClass(this.style.controlBarDefinitionPanelItemInvalid)
      //   }
      // })
    })(definitions)
  }
  setPlaybackRate(playbackRate) {
    this.statefulDelegate(playbackRate => {
      this.playbackRate = playbackRate
      this.$container.find(this.selector.controlBarPlaybackRatePanelItem).each((index, item) => {
        if (String(this.$(item).data('label')) === String(playbackRate)) {
          this.$(item).addClass(this.style.controlBarPlaybackRatePanelItemSelected)
          this.$container
            .find(this.selector.controlBarPlaybackRateLabel)
            .text(playbackRate === '1.0' ? '倍速' : `${playbackRate}x`)
        } else {
          this.$(item).removeClass(this.style.controlBarPlaybackRatePanelItemSelected)
        }
      })
    })(playbackRate)
  }
  getDefinition() {
    return String(this.definition)
  }
  getPlaybackRate() {
    return Number(this.playbackRate) || 1
  }
  containerChange() {
    this.progressBar.containerChange()
  }
  enable() {
    super.enable()
    this.progressBar.enable()
    this.volumeSlider.enable()
  }
  disable() {
    super.disable()
    this.progressBar.disable()
    this.volumeSlider.disable()
  }
  isPlay() {
    return this.$playButton.css('display') !== 'none'
  }
  isPause() {
    return this.$pauseButton.css('display') !== 'none'
  }
  isReplay() {
    return this.$replayButton.css('display') !== 'none'
  }

  // KEYBOARD
  timeStepBackward() {
    this.progressBar.stepBackward()
  }
  timeStepForward() {
    this.progressBar.stepForward()
  }
  timeStepBackwardDone() {
    this.progressBar.stepBackwardDone()
  }
  timeStepForwardDone() {
    this.progressBar.stepForwardDone()
  }
  volumeUp() {
    this.setVolume(Math.min(1, this.volume + 0.05))
    this.emit(UIEvent.VOLUME_CHANGE)
  }
  volumeDown() {
    this.setVolume(Math.max(0, this.volume - 0.05))
    this.emit(UIEvent.VOLUME_CHANGE)
  }
}

export default ControlBar
